import { post, postJson, deleteApi, put, get, imagePost, putJson,postBlob } from './axios3'

// 参与记录
export const getOrderApply = p => postJson(`/interact-data/order-apply/page`, p)

// 参与记录导出接口
export const exportOrderApply = p => postJson(`/interact-data/order-apply/export`, p)

// 购物打卡-打卡明细-查询
export const getShoppingCheckIn = p => postJson(`/shopping-check-in-activity-cycle/shoppingCheckIn/page`, p)

// 打卡明细导出接口
export const exportShoppingCheckIn = p => postJson(`/shopping-check-in-activity-cycle/shoppingCheckIn/export`, p)

// 活动周期信息查询
export const getCycleInfoList = p => get(`/shopping-check-in-activity-cycle/shoppingCheckIn/cycleInfoList`, p)

// 购物打卡-订单明细-查询
export const orderDetailExports = p => postJson(`/PointActivityEffectDetails/orderDetailExport`, p)
